import { useState, useEffect } from "react";
import logo from "../../../../../assets/images/coachTeamLogo.png";

export const WelcomePanel = ({ game, userName = "JAMES WALKER" }) => {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    if (!game || game.isLive) return;

    const calculateCountdown = () => {
      // Use rawDate for countdown calculation (not formatted date)
      const dateToUse = game.rawDate || game.date;

      if (dateToUse && game.time) {
        // Parse the date properly
        let gameDateTime;
        try {
          // If date is ISO string, extract date part
          const datePart = dateToUse.includes('T') ? dateToUse.split('T')[0] : dateToUse;
          // Combine with time (assuming time is in HH:MM format)
          gameDateTime = new Date(`${datePart}T${game.time}:00`);
        } catch (error) {
          console.error('Error parsing game date/time:', error);
          return;
        }

        const now = new Date();
        const timeDiff = gameDateTime - now;

        if (timeDiff > 0) {
          const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          setCountdown({ days, hours, minutes, seconds });
        } else {
          setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
      }
    };

    // Calculate immediately
    calculateCountdown();

    // Update every second
    const interval = setInterval(calculateCountdown, 1000);

    return () => clearInterval(interval);
  }, [game]);

  if (!game) {
    return (
      <div className="rounded-3xl bg-gradient-to-br from-slate-900 via-slate-900 to-slate-950 p-5 flex flex-col items-center text-center gap-3">
        <div className="w-full flex justify-between text-xs text-slate-300">
          {/* <span>WELCOME, {userName}!</span> */}
        </div>
        <p className="text-slate-400 text-sm py-8">No upcoming games scheduled</p>
      </div>
    );
  }

  const isLive = game.isLive;
  const dateDisplay = game.date || 'TBD';
  const timeDisplay = game.time || '';

  return (
    <div className={`rounded-3xl ${
      isLive
        ? 'bg-gradient-to-br from-red-900 via-red-800 to-red-950 border-2 border-red-500/50'
        : 'bg-gradient-to-br from-slate-900 via-slate-900 to-slate-950'
    } p-5 flex flex-col items-center text-center gap-3 relative`}>
      {/* LIVE Badge */}
      {isLive && (
        <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-bold px-3 py-1 rounded-full flex items-center gap-1.5 shadow-lg">
          <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
          LIVE NOW
        </div>
      )}

      <div className="w-full flex justify-between text-xs text-slate-300">
        {/* <span>WELCOME, {userName}!</span> */}
        {game.streamLink && (
          <a
            href={game.streamLink}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-slate-200 text-[11px] hover:text-white"
          >
            Stream Link
          </a>
        )}
      </div>

      <div className="flex items-start justify-between w-full mt-2 gap-3">
        {/* Home Team */}
        <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
          <img
            src={game.homeLogo || logo}
            alt={game.home || 'Home Team'}
            className="w-16 h-16 rounded-lg object-cover shadow-lg"
          />
          <div className="text-center w-full px-1">
            <span className="text-xs font-semibold text-white block leading-tight break-words">
              {game.home || 'TBD'}
            </span>
            <span className="text-[9px] text-slate-400 block mt-0.5">HOME</span>
          </div>
        </div>

        {/* Center - Countdown or LIVE */}
        <div className="flex flex-col items-center justify-center gap-1 flex-shrink-0">
          {isLive ? (
            <>
              <span className="text-2xl font-bold text-red-400 animate-pulse text-center">
                IN PROGRESS
              </span>
            </>
          ) : (
            <>
              <span className="text-xl font-bold text-slate-300">VS</span>
              <span className="text-[10px] text-slate-400">{dateDisplay}</span>
              <span className="text-[10px] text-slate-400">{timeDisplay}</span>
              <div className="mt-2">
                <span className="text-xl font-semibold tracking-[0.15em] text-white block">
                  {String(countdown.days).padStart(2, '0')} : {String(countdown.hours).padStart(2, '0')} : {String(countdown.minutes).padStart(2, '0')} : {String(countdown.seconds).padStart(2, '0')}
                </span>
                <span className="text-[8px] text-slate-400 tracking-wider block mt-1">
                  DAYS   HRS   MIN   SEC
                </span>
              </div>
            </>
          )}
        </div>

        {/* Away Team */}
        <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
          <img
            src={game.awayLogo || logo}
            alt={game.away || 'Away Team'}
            className="w-16 h-16 rounded-lg object-cover shadow-lg"
          />
          <div className="text-center w-full px-1">
            <span className="text-xs font-semibold text-white block leading-tight break-words">
              {game.away || 'TBD'}
            </span>
            <span className="text-[9px] text-slate-400 block mt-0.5">AWAY</span>
          </div>
        </div>
      </div>

      <p className="text-[11px] text-slate-200 mt-2">
        {isLive ? 'Watch the live broadcast now!' : "Don't miss the live broadcast!"}
      </p>

      {game.streamLink && (
        <a
          href={game.streamLink}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-1 px-5 py-1 rounded-full border border-slate-300 text-[11px] text-white hover:bg-slate-800 transition-colors"
        >
          {isLive ? 'Watch Now' : 'Click here'}
        </a>
      )}
    </div>
  );
};
